import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDisputesOverview(range = '30d') {
  return useQuery({
    queryKey: ['admin', 'disputes', 'overview', range],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${API_BASE}/api/admin/disputes/metrics/overview?range=${range}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
